module.exports = __webpack_public_path__ + "assets/img/vertical-dryer-front-view.0b4c2163.jpg";